module.exports = __webpack_public_path__ + "static/media/open-web.f5cf446b.png";